import { Preferences } from 'pleinchamp-api-client';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '@locales/useTranslation.hook';
import { SettingsState } from '@settings/business/Settings.store';
import { PlcDispatch, RootState } from '@store/store';

interface SettingsHookResult {
  settings: SettingsState;
  save: (preferences: Preferences) => Promise<void>;
  saving: boolean;
  error: string | undefined;
}

export const useSettings = (): SettingsHookResult => {
  const { t } = useTranslation(['common']);
  const settings = useSelector((rootState: RootState) => rootState.settings);
  const dispatch = useDispatch<PlcDispatch>();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | undefined>();

  const save = useCallback(
    async (preferences: Preferences) => {
      setError(undefined);

      setSaving(true);
      try {
        await dispatch.settings.putPreferences(preferences);
      } catch (err) {
        setError(t('common.error.generic'));
      } finally {
        setSaving(false);
      }
    },
    [setError, setSaving]
  );

  return { error, save, saving, settings };
};
